export const PAYMENT_METHODS_QUERY_KEY = 'PAYMENT_METHODS';

export const factoryPaymentMethodsKey = ({ officeId }: { officeId?: string | null }) => [
  PAYMENT_METHODS_QUERY_KEY,
  officeId ?? null,
];
